export default __webpack_public_path__ + "static/media/main_sp.a7858cb5.jpg";